<template>
  <button
    class="LmModalButton flex justify-center items-center min-w-19 h-8 flex justify-center"
    :class="buttonClasses"
    @click.prevent="onClick"
  >
    <lm-loading
      v-if="loading"
      :color="loadingColor"
      :class="{'mr-1': type === 'secondary'}"
    />
    <lm-material-icon
      v-if="icon"
      v-show="!loading"
      :class="iconRight ? 'order-1' : ''"
      :icon="icon"
    />
    <span v-show="!loading" class="order-0">{{ title }}</span>
  </button>
</template>

<script>
import LmLoading from '@/components/ui/LmLoading'
import LmMaterialIcon from '@/components/ui/LmMaterialIcon'

export default {
  name: 'LmModalButton',
  components: {LmMaterialIcon, LmLoading},
  props: {
    title: {
      type: String,
      required: true
    },
    type: {
      validator(v) {
        return ['default', 'primary', 'secondary', 'warning'].indexOf(v) >= 0
          ? v
          : false
      },
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    iconRight: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    buttonClasses() {
      let cc = 'text-s'
      if (this.type === 'primary' || this.type === 'warning') {
        cc = 'text-xxs uppercase'
      }
      if (this.icon && this.iconRight) {
        cc += ' pl-4 pr-2'
      } else if (this.icon && !this.iconRight) {
        cc += ' pl-2 pr-4'
      } else {
        cc += ' px-4'
      }
      if (this.disabled) {
        cc += ' text-gray-300 cursor-not-allowed'
      } else {
        cc += ' cursor-pointer'
        if (this.type === 'primary') {
          cc += ' text-white bg-gray-900 hover:bg-gray-700'
        } else if (this.type === 'secondary') {
          cc += ' text-gray-700 bg-gray-300 hover:text-gray-900'
        } else if (this.type === 'warning') {
          cc += ' text-white bg-error'
        } else {
          cc += ' text-gray-700 hover:bg-gray-300'
        }
      }
      return cc
    },
    loadingColor() {
      return this.type === 'default' || this.type === 'secondary'
        ? '#686868'
        : '#ffffff'
    }
  },
  methods: {
    onClick(e) {
      if (!this.disabled && !this.loading) this.$emit('click', e)
    }
  }
}
</script>

<style>
.js-focus-visible .LmModalButton:focus:not(.focus-visible) {
  outline: none;
}
</style>
